// extracted by css-extract-rspack-plugin
export default {"container":"GrNxyWX_DXc3dqOv"};